import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { Outlet, useLocation } from 'react-router-dom';
import ThematicStudiesLayoutBreadcrumbs from './ThematicStudiesLayoutBreadcrumbs';
import ThematicStudiesSearchBar from './ThematicStudiesSearchBar';

export default function ThematicStudiesLayout() {
    const location = useLocation();
    const shouldReduceMotion = useReducedMotion();
    const pathSegments = location.pathname.split('/').filter(Boolean);
    const isListLevelRoute = pathSegments.length <= 2;

    return (
        <>
            <ThematicStudiesSearchBar />
            <ThematicStudiesLayoutBreadcrumbs />
            {isListLevelRoute ? (
                <Outlet />
            ) : (
                <AnimatePresence mode="wait" initial={false}>
                    <motion.div
                        key={location.pathname}
                        initial={shouldReduceMotion ? { opacity: 1 } : { opacity: 0, y: 8 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={shouldReduceMotion ? { opacity: 1 } : { opacity: 0, y: -8 }}
                        transition={{ duration: shouldReduceMotion ? 0 : 0.2, ease: 'easeOut' }}
                    >
                        <Outlet />
                    </motion.div>
                </AnimatePresence>
            )}
        </>
    );
}
